// NOTE(bryn): TEMPORARY — this entire file is deleted in the follow-up PR that
// flips the persisted write path to canonical StoredMessage and moves editing
// server-side. It exists only so reads tolerate both the legacy LangChain
// (`{ kwargs }`) and canonical StoredMessage (`{ data }`) shapes during that
// transition. Don't build anything durable on it.

type ToolCall = {
  id?: string;
  name: string;
  args?: Record<string, unknown>;
  type?: string;
};

const isRecord = (v: unknown): v is Record<string, unknown> =>
  typeof v === 'object' && v !== null;

const isToolCall = (v: unknown): v is ToolCall =>
  isRecord(v) && typeof v.name === 'string';

export function storedMessageFields(
  data: unknown
): Record<string, unknown> | null {
  if (!isRecord(data)) return null;
  if (isRecord(data.data)) return data.data;
  if (isRecord(data.kwargs)) return data.kwargs;
  return null;
}

export function storedMessageView(data: unknown): {
  content: string;
  toolCalls: ToolCall[];
} {
  const fields = storedMessageFields(data);
  const content = fields?.content;
  const toolCalls = fields?.tool_calls;
  return {
    content: typeof content === 'string' ? content : stringify(content),
    toolCalls: Array.isArray(toolCalls) ? toolCalls.filter(isToolCall) : [],
  };
}

function stringify(content: unknown): string {
  return content == null ? '' : JSON.stringify(content);
}
